import { Injectable, Type } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


import { ModalOptions } from '../../shared/utils/types';

@Injectable({
  providedIn: 'root'
})
export class Modal {
  private modalConfig$ = new BehaviorSubject<{ component: Type<any> | null; isVisible: boolean, options?: ModalOptions }>({
    component: null,
    isVisible: false,
    options: {},
  });

  modal$ = this.modalConfig$.asObservable();

  open(component: Type<any>, options?: ModalOptions) {
    this.modalConfig$.next({ component, options, isVisible: true });
  }

  close() {
    this.modalConfig$.next({ component: null, isVisible: false });
  }
}



